import Service from '@/service/index.js';
import { mapGetters } from 'vuex';
import RegExpObj from '@/utils/regExp.js';
import { validateDate, getUnitByGoodsType } from '@/utils/common.js';
export default {
  props: {
    projectInfo: {
      type: Object,
      default: () => {
        return [];
      }
    }
  },
  data() {
    const validateStartTime = (rule, value, callback) => {
      let date = new Date(new Date().getTime() - 24*60*60*1000);
      if(!value) {
        callback(new Error('请选择开始日期'));
      } else if(validateDate(date, value)) {
        callback(new Error('只能选择今天及以后的时间'));
      } else if(validateDate(value, this.ruleForm.endStartTime)) {
        callback(new Error('开始日期不能晚于结束日期'));
      }else {
        // this.$refs['fundForm'].clearValidate('endStartTime');
        callback();
      }
    };
    const validateEndTime = (rule, value, callback) => {
      let date = new Date(new Date().getTime() - 24*60*60*1000);
      if(!value) {
        callback(new Error('请选择结束日期'));
      } else if(validateDate(date, value)) {
        callback(new Error('只能选择今天及以后的时间'));
      } else if(validateDate(this.ruleForm.planStartTime, value)) {
        callback(new Error('结束日期不能早于开始日期'));
      } else {
        // this.$refs['fundForm'].clearValidate('planStartTime');
        callback();
      }
    };
    // 校验资金来源
    const validateFundsInfo = (rule, value, callback) => {
      let errorMessage = '';
      if (this.fundInfo.length) {
        this.fundInfo.forEach(item => {
          let fund = this.ruleForm.fundsInfo.find(v => v.fundsSourceType === item);
          // if (fund && fund.fundsSourceType === 6 && !fund.fundsSourceDesc) {
          //   errorMessage = '请填写其他来源';
          // } else
          if ( fund && !fund.fundsSource) {
            errorMessage = '请填写已选资金来源对应的资金金额且必须为大于0的数字';
          } else if ( fund && fund.fundsSource && Number(fund.fundsSource) <= 0) {
            errorMessage = '资金金额需要大于0';
          } else if (fund && !fund.fundsSourceProportion) {
            errorMessage = '请填写已选资金来源对应的资金占比且必须为大于0的数字';
          } else if ( fund && fund.fundsSourceProportion && Number(fund.fundsSourceProportion) > 100 || Number(fund.fundsSourceProportion) <= 0) {
            errorMessage = '资金占比只能在0%～100%之间';
          }
        });
      } else if (!this.fundInfo.length) {
        callback(new Error('请选择资金来源'));
      }
      if (errorMessage) {
        callback(new Error(errorMessage));
      } else {
        callback();
      }
    };
    // 校验采购方式
    const validatePurchaseType = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择采购方式'));
      } else if (value === 1) {
        if (!this.ruleForm.increaseAmount) {
          callback(new Error('请输入减价幅度'));
        } else if (this.ruleForm.increaseAmount && !RegExpObj.positiveNumber.test(this.ruleForm.increaseAmount)) {
          callback(new Error('减价幅度需要大于0'));
        } else if (this.ruleForm.increaseAmount && this.ruleForm.increaseAmount % 10 !== 0) {
          callback(new Error('请输入10的整数倍的减价幅度!'));
        } else if (!this.ruleForm.increaseTime) {
          callback(new Error('请选择限时报价周期'));
        } else if (Number(this.ruleForm.increaseTime) < 60 ) {
          callback(new Error('限时报价周期不能小于60秒'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 项目周期  交货期
    const validateDeliveryDate = (rule, value, callback) => {
      if (!value && value !== 0) {
        if(this.projectTypeOfPur === 2) {
          callback(new Error('请输入交货期'));
        } else {
          callback(new Error('请输入项目周期'));
        }
      } else if(value <= 0) {
        if(this.projectTypeOfPur === 2) {
          callback(new Error('请输入交货期'));
        } else {
          callback(new Error('请输入项目周期'));
        }
      } else {
        callback();
      }
    };
    // 校验保证金
    const validateMargin = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error(`请选择${this.marginLabel}比例`));
      } else {
        callback();
      }
    };
    // 校验履约保证金
    const validatePerformanceBond = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('请输入履约保证金，不超过10%'));
      } else if (Number(value) > 10 || Number(value) < 0) {
        callback(new Error('履约保证金不超过10%且不能小于0'));
      } else {
        callback();
      }
    };
    // 校验农民工工资保证金
    // const validateMigrantWorkersMargin = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请输入农民工工资保证金'));
    //   } else if (Number(value) > 100 || Number(value) < 0) {
    //     callback(new Error('农民工工资保证金比例只能在0%～100%之间'));
    //   } else {
    //     callback();
    //   }
    // };
    const validateEngineeringWarranty = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入工程质保金'));
      } else if (Number(value) > 100 || Number(value) < 0) {
        callback(new Error('工程质保金比例只能在0%～100%之间'));
      } else {
        callback();
      }
    };
    return {
      pickerOptions0: { // 今天之前的日期不可选
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      date: [],
      earnestMoneyArr: [{value: 2, code: 2}, {value: 1, code: 1}],
      fundsSourceType: [],
      purchaseType: [],
      qualificationReview: [],
      fundInfo: [],
      marginLabel: '竞价保证金',
      ruleForm: {
        purchaseBudget: '', // 采购预算(含税)
        fundsInfo: [
          {fundsSourceType: 1, fundsSource: '', fundsSourceProportion: '', fundsSourceDesc: ''},
          {fundsSourceType: 2, fundsSource: '', fundsSourceProportion: '', fundsSourceDesc: ''},
          {fundsSourceType: 3, fundsSource: '', fundsSourceProportion: '', fundsSourceDesc: ''},
          {fundsSourceType: 4, fundsSource: '', fundsSourceProportion: '', fundsSourceDesc: ''},
          {fundsSourceType: 5, fundsSource: '', fundsSourceProportion: '', fundsSourceDesc: ''},
          {fundsSourceType: 6, fundsSource: '', fundsSourceProportion: '', fundsSourceDesc: ''}
        ],
        planStartTime: '',
        endStartTime: '',
        purchaseType: '',
        margin: 2,
        marginValue: '',
        purchaseFileFee: '',
        performanceBond: '0',
        migrantWorkersMargin: 5,
        engineeringWarranty: 0,
        increaseTime: '',
        increaseAmount: '',
        qualificationReview: '2',
        deliveryDate: '' // 项目周期或交货期
      },
      increaseTimeDate: [
        {code: '60', value: '60'},
        {code: '120', value: '120'},
        {code: '180', value: '180'},
        {code: '240', value: '240'},
        {code: '300', value: '300'}
      ],
      increaseAmountList: ['10', '100', '500', '1000', '10000'],
      rules: {
        purchaseBudget: [
          { required: true, message: '请输入采购预算（含税）且必须为大于0的数字', trigger: 'blur' },
          { pattern: RegExpObj.positiveNumber, message: '采购预算必须为大于0的数字', trigger: 'blur'}
        ],
        fundsInfo: [
          { required: true, type: Array, validator: validateFundsInfo, trigger: 'change' }
        ],
        // planStartTime: [
        //   { required: true, message: '请选择计划开始时间', trigger: 'change' }
        // ],
        // endStartTime: [
        //   { required: true, message: '请选择计划结束时间', trigger: 'change' }
        // ],
        planStartTime: [
          { required: true, validator: validateStartTime, trigger: 'change' }
        ],
        endStartTime: [
          { required: true, validator: validateEndTime, trigger: 'change' }
        ],
        deliveryDate: [
          { required: true, validator: validateDeliveryDate, trigger: 'blur' },
          { pattern: RegExpObj.nums, message: '交货期为大于0的正整数', trigger: 'blur'}
        ],
        purchaseType: [
          { required: true, validator: validatePurchaseType, trigger: 'change' }
        ],
        margin: [
          { required: true, validator: validateMargin, trigger: 'change' }
        ],
        purchaseFileFee: [
          { required: true, message: '请先输入采购预算（含税）', trigger: 'change' }
        ],
        performanceBond: [
          { required: true, validator: validatePerformanceBond, trigger: 'blur' }
        ],
        // migrantWorkersMargin: [
        //   { required: true, validator: validateMigrantWorkersMargin, trigger: 'blur' }
        // ],
        engineeringWarranty: [
          { required: true, validator: validateEngineeringWarranty, trigger: 'blur' }
        ],
        qualificationReview: [
          { required: true, message: '请选择资格审核方式', trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    projectTypeOfPur() {
      this.$refs['fundForm'].resetFields();
      this.fundInfo = [];
      this.ruleForm.fundsInfo.forEach(v => {
        v.fundsSource = v.fundsSourceProportion = '';
      });
      this.date = [];
      console.log(this.projectTypeOfPur, this.projectTypeOfPur === 2, 'this.projectTypeOfPur');
      // if (this.projectTypeOfPur === 1) {
      //   this.$set(this.rules.planStartTime, 0, { required: true, message: '请选择计划工期', trigger: 'change' });
      // } else
      if(this.projectTypeOfPur === 2){
        this.$set(this.rules.deliveryDate, 0, { required: true, message: '请输入交货期', trigger: 'blur' });
        this.$set(this.rules.deliveryDate, 1, { pattern: RegExpObj.nums, message: '交货期为大于0的正整数', trigger: 'blur'});
      } else if(this.projectTypeOfPur === 3){
        this.$set(this.rules.deliveryDate, 0, { required: true, message: '请输入项目周期', trigger: 'blur' });
        this.$set(this.rules.deliveryDate, 1, { pattern: RegExpObj.positiveNumber, message: '项目周期必须大于0', trigger: 'blur'});
      }
    },
    projectInfo () {
      Object.keys(this.ruleForm).forEach((key) => {
        if (this.projectInfo && this.projectInfo[key] !== '') {
          // if (key === 'endStartTime' || key === 'planStartTime') {
          //   this.ruleForm[key] = this.projectInfo[key] && this.projectInfo[key].substring(0, 10);
          //   this.$set(this.date, 0, this.ruleForm.planStartTime);
          //   this.$set(this.date, 1, this.ruleForm.endStartTime);
          // } else
          if (key === 'fundsInfo') {
            this.projectInfo.fundsInfo.forEach(item => {
              let fund = this.ruleForm.fundsInfo.find(v => v.fundsSourceType === item.fundsSourceType);
              let fundIndex = this.ruleForm.fundsInfo.findIndex(v => v.fundsSourceType === item.fundsSourceType);
              if (fund && fundIndex !== -1) {
                this.$set(this.fundInfo, fundIndex, fund.fundsSourceType);
                this.$set(this.ruleForm.fundsInfo, fundIndex, {fundsSourceType: item.fundsSourceType, fundsSource: item.fundsSource, fundsSourceProportion: item.fundsSourceProportion, fundsSourceDesc: item.fundsSourceDesc});
              }
            });
          } else {
            this.ruleForm[key] = this.projectInfo[key];
          }
        }
      });
    },
    // 采购预算
    'ruleForm.purchaseBudget': {
      handler() {
        this.calcPercent2();
      },
      deep: true
    },
    // 采购方式
    'ruleForm.purchaseType': {
      handler(value) {
        if (value) {
          this.$store.commit('UPDATE_PURCHASE_TYPE', value);
          this.$store.dispatch('updatePurchaseProcessList', { projectType: this.projectTypeOfPur, purchaseType: value });
        }
        // 一般招标、依法必招
        if ([4, 5].includes(Number(value))) {
          this.marginLabel = '交易保证金';
        } else {
          this.marginLabel = '竞价保证金';
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'projectTypeOfPur',
      'purchaseProcessList',
      'goodsType',
      'getTenantParams'
    ]),
    purchaseTypeList () {
      let tempList = [];
      if (this.projectTypeOfPur === 1) {
        if (this.getTenantParams.citytitle === '颍上县') {
          tempList = [4, 5];
        } else {
          tempList = [3, 4, 5];
        }
        // TODO 临时
        // tempList = [3];
      } else if(this.projectTypeOfPur === 2){
        // 货物类型 1活体 2其他
        tempList = this.goodsType === 2 ? [1] : [3];
      } else if(this.projectTypeOfPur === 3) {
        tempList = [3];
      }
      return this.purchaseType.filter(item => {
        return tempList.includes(item.code);
      });
    }
  },
  created () {
    !this.$route.query.id && this.$store.commit('UPDATE_PURCHASE_TYPE', '');
    this.getDictionarySelect();
  },
  methods: {
    getUnitByGoodsType,
    // 资金来源 百分比计算
    calcPercent2() {
      this.ruleForm.fundsInfo.forEach((item) => {
        let fundsSource = item.fundsSource;
        if(fundsSource) {
          // 计算占比
          let fundsSourceProportion = ((fundsSource / this.ruleForm.purchaseBudget) * 100).toFixed(2);
          item.fundsSourceProportion = fundsSourceProportion;
        } else {
          item.fundsSourceProportion = null;
        }
      });
    },
    // 资金来源 百分比计算
    calcPercent(index) {
      // 资金
      let fundsSource = this.ruleForm.fundsInfo[index].fundsSource;
      // 计算占比 (资金 / 采购预算) * 100
      let fundsSourceProportion = ((fundsSource / this.ruleForm.purchaseBudget) * 100).toFixed(2);
      this.$set(this.ruleForm.fundsInfo, index, { ...this.ruleForm.fundsInfo[index], fundsSourceProportion });
    },
    // 校验
    validateSumPrice (rule, value, callback) {
      // 资金来源 总金额
      let fundsSourceSum = 0;
      // 资金来源 占比
      let fundsSourceProportion = 0;
      this.ruleForm.fundsInfo.map(item => {
        fundsSourceSum += Number(item.fundsSource);
        fundsSourceProportion += Number(item.fundsSourceProportion);
      });

      // 如果总金额不等于采购预算
      if(fundsSourceSum !== Number(this.ruleForm.purchaseBudget) || fundsSourceProportion !== 100) {
        callback(new Error('资金来源金额总计必须等于采购预算，且占比必须等于100%'));
      } else {
        callback();
      }
    },
    // 获取字典项
    getDictionarySelect() {
      const arr = [
        ['fundsSourceType', 'FUNDS_SOURCE'], // 资金来源
        ['purchaseType', 'PURCHASE_TYPE'], // 采购方式
        ['qualificationReview', 'QUALIFICATION_REVIEW']
      ];
      arr.forEach((value) => {
        if (!value.length) {
          return;
        }
        Service.getSelectList(value[1]).then(res => {
          if (res && res.code === '0') {
            res.data.forEach(v => { v.code = Number(v.code);});
            this[value[0]] = res.data;
            if (value[0] === 'fundsSourceType') {
              this.fundsSourceType.forEach(v => {
                let fund = this.ruleForm.fundsInfo.find(item => item.fundsSourceType === v.code);
                fund.fundsSourceDesc = v.value;
                // if (fund && fund.fundsSourceType !== 6) {
                //   fund.fundsSourceDesc = v.value;
                // }
              });
            }
            // //  颍上县产权集体采购-工程建设项目-采购方式隐藏“一次性报价”方式。
            // if(this.getTenantParams.citytitle === '颍上县' && Number(this.projectTypeOfPur) === 1) {
            //   this.purchaseType = this.purchaseType.filter(v => Number(v.code) !== 3);
            //   console.log(this.projectTypeOfPur, this.purchaseType, 'this.projectTypeOfPur');
            // }
          }
        });
      });
    },
    // 采购预算(含税)与保证金\资金来源关联\采购文件费用
    countMarginValue() {
      this.ruleForm.purchaseFileFee = '';
      if (!this.ruleForm.purchaseBudget) {return;}
      // 计算保证金
      if (this.ruleForm.margin && this.ruleForm.purchaseBudget) {
        this.ruleForm.marginValue = (this.ruleForm.margin/100 * (this.ruleForm.purchaseBudget)).toFixed(0);
      } else {
        this.ruleForm.marginValue = 0;
      }
      // 计算采购文件费用
      if (this.ruleForm.purchaseBudget > 5000000) {
        this.ruleForm.purchaseFileFee = 500;
      } else if (this.ruleForm.purchaseBudget > 1000000 && this.ruleForm.purchaseBudget <= 5000000) {
        this.ruleForm.purchaseFileFee = 400;
      } else if (this.ruleForm.purchaseBudget > 500000 && this.ruleForm.purchaseBudget <= 1000000) {
        this.ruleForm.purchaseFileFee = 300;
      } else if (this.ruleForm.purchaseBudget > 300000 && this.ruleForm.purchaseBudget <= 500000) {
        this.ruleForm.purchaseFileFee = 200;
      } else {
        this.ruleForm.purchaseFileFee = 100;
      }
    },
    // 清空资金来源
    countFundsSourceProportion() {
      this.ruleForm.fundsInfo.forEach(item => {
        if (!this.fundInfo.find(v => v === item.fundsSourceType) && item.fundsSource) {
          item.fundsSource = item.fundsSourceProportion = '';
        }
      });
    },
    onChangeDate (event) {
      this.ruleForm.planStartTime = event && event[0];
      this.ruleForm.endStartTime = event && event[1];
    },
    test() {
      // 校验资金来源金额
      this.rules['fundsInfo'].push({ validator: this.validateSumPrice, trigger: 'blur' });
      return new Promise((resolve, reject) => {
        this.$refs['fundForm'].validate((valid) => {
          this.rules['fundsInfo'].pop();
          if (valid) {
            if(this.ruleForm.deliveryDate) {
              this.ruleForm.deliveryDate = Number(this.ruleForm.deliveryDate);
            }
            resolve(JSON.parse(JSON.stringify(this.ruleForm)));
          } else {
            reject();
          }
        });
      });
    }
  }
};
